module.exports = __webpack_public_path__ + "static/media/FPI-and-me-en-program.1af36ba0.png";